import * as AiIcons  from "react-icons/ai";
import * as IoIcons  from "react-icons/io5";
import * as FiIcons  from "react-icons/fi";
import React, {useEffect} from 'react';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";

function Home() {
    useEffect(() => {
        const map = L.map("map").setView([-6.227948696671188, 106.8062666545336], 19);

        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap",
        }).addTo(map);

        const markers = [
            { position: [-6.22814575, 106.80710720], popup: "Head Office" },
            { position: [-6.227948696671188, 106.8062666545336], popup: "Branch Office" }
        ];

        markers.forEach(({ position, popup }) => {
            L.marker(position, {
                icon: L.icon({
                    iconUrl: markerIconPng,
                    shadowUrl: markerShadowPng,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                }),
            }).bindPopup(popup).addTo(map);
        });

        return () => {
            map.remove();
        };
    }, []);

    return (
        <div className={"pt-16 flex flex-col h-screen relative"}>
            <div id="map" style={{width: "100%", height: "80vh", zIndex:"0"}}/>
            <div
                className={"absolute flex flex-col space-y-5 px-5 py-5 bottom-24 left-2 right-2 lg:right-auto bg-white duration-300 opacity-100"}
                style={{zIndex: "1"}}>
                <p className="text-3xl font-bold m-0">Hubungi Kami</p>
                <div className={"flex flex-col"}>
                    <div className="flex flex-row items-center space-x-2">
                        <AiIcons.AiOutlineMail className="text-xl"/>
                        <p className="text-xs m-0">customer.care@danai.id</p>
                    </div>
                </div>
                <div className={"flex flex-col"}>
                    <div className="flex flex-row items-center space-x-2">
                        <IoIcons.IoCallOutline className="text-xl"/>
                        <p className="text-xs m-0">021 - 5010 3363</p>
                    </div>
                </div>
                <div className={"flex flex-col"}>
                    <div className="flex flex-row items-center space-x-2">
                        <AiIcons.AiOutlineWhatsApp className="text-xl"/>
                        <p className="text-xs m-0">(+62) 815 6151 295 - WA Only</p>
                    </div>
                </div>
                <div className={"flex flex-col"}>
                    <div className="flex flex-row space-x-2">
                        <FiIcons.FiMapPin className="text-xl"/>
                        <div className={"flex flex-col"}>
                            <p className="text-sm font-bold m-0 w-auto lg:w-72">Head Office</p>
                            <p className="text-xs m-0 w-auto lg:w-72">Prosperity Tower Lantai 20 District 8 SCBD Lot 28
                                JL Jend Sudirman kav 52-53 Jakarta 12190</p>
                        </div>
                    </div>
                </div>
                <div className={"flex flex-col"}>
                    <div className="flex flex-row space-x-2">
                        <FiIcons.FiMapPin className="text-xl"/>
                        <div className={"flex flex-col"}>
                            <p className="text-sm font-bold m-0 w-auto lg:w-72">Office</p>
                            <p className="text-xs m-0 w-auto lg:w-72">Treasury Tower Unit 9-I District 8 SCBD Lot 28 JL
                                Jend
                                Sudirman kav 52-53 Jakarta 12190</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
